import PropTypes from 'prop-types';
import React from 'react';
import { find, isEmpty, map, orderBy } from 'lodash';
import { formatDuration } from "../utils";
var Closed = function Closed() {
  return /*#__PURE__*/React.createElement("div", {
    className: "hours-of-operation-day__closed"
  }, "Closed");
};
var HoursOfOperationDay = function HoursOfOperationDay(_ref) {
  var day = _ref.day,
    hours = _ref.hours;
  var _ref2 = find(hours, {
      day_of_week: day
    }) || {},
    hours_of_operation = _ref2.hours_of_operation;
  var hoursDisplay = map(orderBy(hours_of_operation, 'opens_at'), formatDuration).join(', ');
  return /*#__PURE__*/React.createElement("div", {
    className: "hours-of-operation-day"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hours-of-operation-day__day-label"
  }, day), /*#__PURE__*/React.createElement("div", {
    className: "hours-of-operation-day__hours"
  }, isEmpty(hours_of_operation) ? /*#__PURE__*/React.createElement(Closed, null) : hoursDisplay));
};
HoursOfOperationDay.propTypes = {
  day: PropTypes.string.isRequired,
  hours: PropTypes.array.isRequired
};
export default HoursOfOperationDay;